<template>
    <div></div>
</template>

<script>
export default {
    name: 'design-2021-internships-edit-details-tab-component',
    props: ['internshipIn', 'internshipTagsIn', 'studentsIn'],
    data() {
        return {
            internship: this.internshipIn,
            internshipSaved: this.internshipIn,
            name: this.internshipIn.name,
            description: this.internshipIn.description,
            location: this.internshipIn.location,
            slots: this.internshipIn.slots,
            tags: this.internshipIn.internship_tags,
            file: null,
            banner_preview: this.internshipIn.file ? this.internshipIn.file.path : '',
        };
    },
    methods: {
        showPreview(evt) {
            const file = evt.target.files[0];
            this.banner_preview = URL.createObjectURL(file);
        },
        // loosingTags() {
        //     let lostTags = [];
        //     const losingTags = !this.internshipSaved.internship_tags.every(tag => {
        //         const tagKeptBool = this.tags.includes(tag);
        //         if (!tagKeptBool) {
        //             lostTags.push(tag.id)
        //         }
        //         return tagKeptBool;
        //     });
        //     let data = {
        //         removedTags: lostTags,
        //         newTags: this.tags.map(tag => tag.id)
        //     }
        //     if (losingTags) {
        //         axios.post(this.routes.internshipCheckStudents(this.internshipIn.id), data).then(
        //             (response) => {
        //                 if (response.data.length === 0) {
        //                     this.save()
        //                 } else {
        //                     this.$refs['tagless-students-modal'].load(response.data);
        //                 }
        //             }
        //         ).catch(function (error) {
        //         })
        //     } else {
        //         this.save()
        //     }
        // },
        // lessSlotsthenStudentsCheck() {
        //     if (this.slots < this.studentsIn.length) {
        //         this.$refs['too-many-students-modal'].load(this.slots);
        //     } else {
        //         this.loosingTags()
        //     }
        // },
        save(deleteStudents = []) {
            this.alert.saving();
            const tagIds = this.tags.map((tag) => tag.id);
            const formData = new FormData();
            formData.append('name', this.name);
            formData.append('description', this.description);
            formData.append('location', this.location);
            formData.append('slots', this.slots);
            if (this.file) {
                formData.append('file', this.file);
            }
            for (let i = 0; i < tagIds.length; i++) {
                formData.append('tags[' + i + ']', tagIds[i]);
            }
            for (let i = 0; i < deleteStudents.length; i++) {
                formData.append('deletestudents[' + i + ']', deleteStudents[i]);
            }

            const headers = { 'Content-Type': 'multipart/form-data' };

            axios
                .post(this.routes.internshipUpdate(this.internshipIn.id), formData, { headers: headers })
                .then((response) => {
                    this.alert.success();
                    this.internship = response.data;
                    this.internshipSaved = response.data;
                })
                .catch(function (error) {
                    this.alert.ajaxError(error);
                });
        },
    },
};
</script>

<style scoped lang="scss">
.edit-internship {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    input,
    select,
    textarea {
        margin-bottom: 0;
    }

    .internship-banner-edit-upload ::v-deep {
        height: 51px;

        label {
            margin-bottom: 0;
        }

        .form-file-text {
            color: $text-muted-color;
        }
    }

    .btn-update-internship {
        align-self: flex-end;
        margin-top: map-get($grid-gutter-spacing, 'forty-two');
    }
}

.internship-banner-preview {
    margin-bottom: $grid-gutter-width;

    img {
        object-fit: cover;
        object-position: center;
        width: 100%;
        height: 150px;
    }
}
</style>
